import { Component, OnInit } from '@angular/core';
import { DecoratorFactory } from './decoration-base/decorator-factory';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { SharedDataService } from './services/shared-data.service';
import { IShortLogger, Log } from './services/logger.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'Cloud Labs';
  private readonly logger: IShortLogger<AppComponent> = Log.create(AppComponent);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedDataService
  ) {}

  ngOnInit() {
    // Debug decorator state after app initialization
    this.logger.d('App component initialized - checking decorator state:');
    this.logger.d('All decorator names:', DecoratorFactory.getAllDecoratorNames());
    this.logger.d('All component names:', DecoratorFactory.getRegisteredComponentNames());
    this.logger.d('Cloud-resource components:', DecoratorFactory.getDecoratedComponents('cloud-resource'));

    this.getMenuDetails();
  }


  getMenuDetails() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.route.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child;
        }),
        filter(route => !!route),
        mergeMap(route => route!.data)
      )
      .subscribe(data => {
        if (data['title']) {
          this.sharedService.updateSelectedMenu(data['title']);
        }
      });
  }
}
